//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateComputed } from '../../../../common/functions/roles-computed-generator';
import Alcada from './Alcada';
import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';
import { convertToMoney } from '../../../../common/functions/helpers';

export default {
  components: {
    Confirm,
  },
  data() {
    return {
      alcadaResources: this.$api.alcada(this.$resource),
      listaAlcadas: [],
      esperar: false,
      headers: [
        { text: this.$tc('label.fluxo', 1), value: 'fluxo', sortable: true },
        { text: this.$tc('label.descricao', 1), value: 'descricao', sortable: true },
        { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: true },
        { text: this.$tc('label.estrutura_usuario', 1), value: 'nom_estrutura_usuario', sortable: true },
        { text: this.$tc('label.valor_inicial', 1), value: 'vlr_limite_inicial', sortable: true },
        { text: this.$tc('label.valor_final', 1), value: 'vlr_limite_final', sortable: true },
        { text: '', value: 'acoes', sortable: false },
      ],
      pagination: { },
      totalPage: 0,
      searchQuery: '',
      registros: [],
      selected: [],
    };
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  props: {
    title: String,
  },
  computed: {
    filteredList() {
      return [];
    },
    ...generateComputed('Alcada', [
      'canAccessCRUD',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    convertToMoney,
    ativarInativarRegistros() {
      const parametros = [];
      this.selected.forEach((item) => {
        parametros.push({ id: item.id, indAtivo: item.indAtivo });
      });

      this.alcadaResources.ativarInativarRegistros(parametros)
        .then(() => {
          this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
          this.limparSelecionados();
          this.filtrar();
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscar() {
      if (this.searchQuery) {
        this.pagination.page = 1;
      }

      const params = {
        descricao: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      this.alcadaResources.listar(params).then((response) => {
        this.registros = response.data.resposta;
        this.montarObjetoAlcadas();
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    getSearchQuery() {
      return this.searchQuery;
    },
    limparSelecionados() {
      this.selected = [];
    },
    dialogConfirmarInativacao() {
      this.$refs.dialogConfirmaInativacao.open();
    },
    montarObjetoAlcadas() {
      this.listaAlcadas = this.registros.map((data) => {
        const alcada = new Alcada();
        alcada.construirAPartirDaConsultaCompleta(data);
        return alcada;
      });
    },
    onEditarAlcada(alcada) {
      if (!alcada.desAtributos) {
        alcada.desAtributos = { regional: false };
      }
      this.$emit('PESQUISA_ALCADA_EDITAR', alcada);
    },
    validateConflitosValores(row) {
      this.valuesErro = null;
      let status = true;
      if (!this.rowEdit.indSemValorFim && row.vlrLimiteInicial > row.vlrLimiteFinal) {
        this.valuesErro = 'vlr_inicial_maior_vlr_final';
        status = false;
      }
      return status;
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    mudarOrdenacao(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.listaAlcadas.slice();
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/alcada/AlcadaTabela.vue?vue&type=script&lang=js&